<div class="p-4">
  <p class="title is-size-5" translate>overview.basicInfo.basicInfo</p>
  <div class="is-flex is-justify-content-space-between">
    <div class="is-flex is-flex-direction-column">
      @if (!isDisabled()) {
        <span translate>kwh.basicInfo.url</span>
      }
      <span translate>kwh.basicInfo.urlTesting</span>
      @if (isAtruvia) {
        <span translate>kwh.basicInfo.urlAtruvia</span>
      }

      <br />
      <span translate>kwh.basicInfo.email</span>
      <span translate>kwh.basicInfo.fax</span>
    </div>
    <div class="is-flex is-flex-direction-column">
      @if (!isDisabled()) {
        <a
          class="has-text-primary has-text-weight-bold"
          [href]="$safeNavigationMigration(kwhSettings()?.clientUrl)"
          target="_blank"
        >
          {{ kwhSettings()?.clientUrl }}
        </a>
      }

      <a
        class="has-text-primary has-text-weight-bold"
        (click)="openCredentialsModal()"
      >
        {{ kwhSettings()?.clientUrlTesting }}
      </a>

      @if (isAtruvia) {
        <a
          class="has-text-primary has-text-weight-bold"
          (click)="openCredentialsModal(true)"
        >
          https://10090901.test.kwh.fino.digital
        </a>
      }

      <br />

      <strong>{{ kwhSettings()?.courierEmail }}</strong>
      <strong>{{ kwhSettings()?.fax }}</strong>
    </div>
  </div>
</div>
